import type { App } from 'vue'
import AppSubmenu from './app-submenu.vue'
import AppSubmenuItem from './app-submenu-item.vue'

export const useSubMenu = {
  install (app: App) {
    app.component('AppSubmenu', AppSubmenu)
    app.component('AppSubmenuItem', AppSubmenuItem)
  },
}

declare module '@vue/runtime-core' {
  export interface GlobalComponents {
    AppSubmenu: typeof AppSubmenu,
    AppSubmenuItem: typeof AppSubmenuItem,
  }
}
